import { IgnorableNetworkError } from '@/Factories/BookingkitApi/Errors/IgnorableNetworkError';

export class CanceledRequestError extends IgnorableNetworkError {
    static fromCanceledRequest() {
        return new CanceledRequestError('This request was canceled by a cancel token');
    }
}

export default { CanceledRequestError };
